module.exports = __webpack_public_path__ + "img/glow-yellow2-large.18d44b0b.png";